import React, { useState, useEffect } from "react";
import SaapApi from "./sdk/SaapApi";
import "./App.css";
// import HttpService from "./sdk/HttpAxios";

function App() {
  const [token, setToken] = useState(
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhIjoxMCwiYiI6NCwiYyI6ImV5SmhJam8yTENKaUlqbzBmUS5leUpoSWpvek1EQXhOREFzSW1JaU9qTXdNREUwTUN3aVl5STZJbXBaUnpKVVltNW5URklyWWxkUVNrdENVVGRtY25jOVBTSXNJbVFpT2pFc0ltVWlPakUzTkRVd05EUTVNRFVzSW1ZaU9pMHlORFlzSW1jaU9qVTJNemQ5LlFBZndNQXJwVERRR2ViUHgzTkFGb2JkSjBneTY3cFZaWVY2RlNyQlNZOHM9IiwiZCI6MCwiZSI6IjNDOkUwOjAyOjFBOjRCOkI0IiwiZiI6MTAwLCJnIjoxMCwiaCI6Ik8xNzQ1MDQ0NjA0Ljc3NyIsImkiOjMwMDE0MH0.RO-zjZH2wOSgIUBq1rKpZhcQybR-Ks2vr839Lhf4Nis"
  );

  //{appType: 10, algoType: 6, sdkId: "iRVUCzEMSAem65VbBovAPA==", boxId: "9"}
  // {
  //     "ResponseCode": 0,
  //     "ResponseMessage": "Success",
  //     "ResponseCodeText": "SUCCESS",
  //     "Data": {
  //         "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhIjoxMCwiYiI6NCwiYyI6ImV5SmhJam8yTENKaUlqbzBmUS5leUpoSWpvME5EY3dNVEEyTENKaUlqbzBORGN3TVRBMkxDSmpJam9pYWxsSE1sUmlibWRNVWl0aVYxQktTMEpSTjJaeWR6MDlJaXdpWkNJNk15d2laU0k2TVRjek1qUXpOelkxTkN3aVppSTZMVEkwTml3aVp5STZOVFl6TjMwLmF4ZStlUTV5cHFmU0V2SjNOZGZGWkNhVXEyd052ME1hMWVwTEtGdUU5cG89IiwiZCI6MjMwMTI2MDAxLCJlIjoiODQ6NzI6OTM6M0M6NjE6MzIiLCJmIjoxMDAsImciOjEwLCJoIjoiTzE3MzI0MzczNTQuMjE0IiwiaSI6NDQ3MDEwNn0.Zx4yDP4G33mUH_JkY92eYexMGN1yX1Nmf7ITBsa7V7E"
  //     }
  // }

  const [supportsBluetooth, setSupportsBluetooth] = useState(false);
  const [isDisconnected, setIsDisconnected] = useState(true);
  const [batteryLevel, setBatteryLevel] = useState(null);

  const [api, setApi] = useState(null);

  // When the component mounts, check that the browser supports Bluetooth
  useEffect(() => {
    console.log("STARTING..", navigator.bluetooth);

    if (navigator.bluetooth) {
      setSupportsBluetooth(true);
    }
    const api = SaapApi.getInstance();
    api.init("saap-esore-web");
    api.setListener({
      onNotification: (code, msg, info) => {
        console.log("APP ON NOTIFICATION:", code, msg, info);
      },
    });
    setApi(api);
    // new HttpService().login();
  }, []);

  /**
   * Let the user know when their device has been disconnected.
   */
  const onDisconnected = (event) => {
    alert(`The device ${event.target} is disconnected`);
    setIsDisconnected(true);
  };

  /**
   * Update the value shown on the web page when a notification is
   * received.
   */
  const handleCharacteristicValueChanged = (event) => {
    setBatteryLevel(event.target.value.getUint8(0) + "%");
  };

  /**
   * Attempts to connect to a Bluetooth device and subscribe to
   * battery level readings using the battery service.
   */
  const connectToDeviceAndSubscribeToUpdates = async () => {
    // filters: [{
    //     manufacturerData: [{
    //       companyIdentifier: 0x00e0,
    //       dataPrefix: new Uint8Array([0x01, 0x02])
    //     }]
    //   }],

    // try {
    //   if (navigator.bluetooth) console.log("Scan..", navigator.bluetooth);
    //   console.log("Start scanning..");

    //   const scan = await navigator.bluetooth.requestScan({
    //     acceptAllAdvertisements: true,
    //   });

    //   console.log(" active: " + scan.active);
    //   console.log(" keepRepeatedDevices: " + scan.keepRepeatedDevices);

    //   navigator.bluetooth.addEventListener("advertisementreceived", (event) => {
    //     console.log("Advertisement received.");
    //     console.log("  Device Name: " + event.device.name);
    //     console.log("  Device ID: " + event.device.id);
    //     console.log("  RSSI: " + event.rssi);
    //     console.log("  TX Power: " + event.txPower);
    //     console.log("  UUIDs: " + event.uuids);
    //     event.manufacturerData.forEach((valueDataView, key) => {
    //       console.log("Manufacturer", key, valueDataView);
    //     });
    //     event.serviceData.forEach((valueDataView, key) => {
    //       console.log("Service", key, valueDataView);
    //     });
    //   });

    //   setTimeout(stopScan, 10000);
    //   function stopScan() {
    //     console.log("Stopping scan...");
    //     scan.stop();
    //     console.log("Stopped.  scan.active = " + scan.active);
    //   }
    // } catch (error) {
    //   console.log("Argh! " + error);
    // }
    // return;

    try {
      // Search for Bluetooth devices that advertise a battery service
      const device = await navigator.bluetooth.requestDevice({
        //filters: [{services: ['battery_service']}]
        filters: [
          { name: "LOKR" },
          { manufacturerData: [{ companyIdentifier: 0x4c52 }] },
        ], // Filter by manufacturer data],
        acceptAllDevices: false,
        // name: "LOKR",
        // name: "E0:B9:45:90:86:2D", 3C:E0:02:1A:4B:B4
      });

      console.log("DEVICE", device);

      setIsDisconnected(false);

      // Add an event listener to detect when a device disconnects
      device.addEventListener("gattserverdisconnected", onDisconnected);

      // Try to connect to the remote GATT Server running on the Bluetooth device
      const server = await device.gatt.connect();

      // Get the battery service from the Bluetooth device
      const service = await server.getPrimaryService("battery_service");

      // Get the battery level characteristic from the Bluetooth device
      const characteristic = await service.getCharacteristic("battery_level");

      // Subscribe to battery level notifications
      characteristic.startNotifications();

      // When the battery level changes, call a function
      characteristic.addEventListener(
        "characteristicvaluechanged",
        handleCharacteristicValueChanged
      );

      // Read the battery level value
      const reading = await characteristic.readValue();

      // Show the initial reading on the web page
      setBatteryLevel(reading.getUint8(0) + "%");
    } catch (error) {
      console.log(`There was an error: ${error}`);
    }
  };

  const executeToken = async () => {
    // let token = await new HttpService().post(
    //   "/saa/terminals/boxes/service/token",
    //   {
    //     appType: 10,
    //     algoType: 6,
    //     sdkId: "iRVUCzEMSAem65VbBovAPA==",
    //     boxId: "31",
    //   }
    // );
    // console.log("TOKEN", token.token);

    await api.executeToken(
      0,
      token, //"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhIjoxMCwiYiI6NCwiYyI6ImV5SmhJam8yTENKaUlqbzBmUS5leUpoSWpvek1EQXhOREFzSW1JaU9qTXdNREUwTUN3aVl5STZJbXBaUnpKVVltNW5URklyWWxkUVNrdENVVGRtY25jOVBTSXNJbVFpT2pFc0ltVWlPakUzTkRVd05EUTVNRFVzSW1ZaU9pMHlORFlzSW1jaU9qVTJNemQ5LlFBZndNQXJwVERRR2ViUHgzTkFGb2JkSjBneTY3cFZaWVY2RlNyQlNZOHM9IiwiZCI6MCwiZSI6IjNDOkUwOjAyOjFBOjRCOkI0IiwiZiI6MTAwLCJnIjoxMCwiaCI6Ik8xNzQ1MDQ0NjA0Ljc3NyIsImkiOjMwMDE0MH0.RO-zjZH2wOSgIUBq1rKpZhcQybR-Ks2vr839Lhf4Nis",
      SaapApi.LOCKER_ACTION_UNLOCK
    );
  };

  return (
    <div className="App">
      <h1>Get Device Battery Info Over Bluetooth</h1>
      {supportsBluetooth && !isDisconnected && (
        <p>Battery level: {batteryLevel}</p>
      )}
      <div style={{ padding: "2em" }}>
        {supportsBluetooth && isDisconnected && (
          <button onClick={connectToDeviceAndSubscribeToUpdates}>
            Connect to a Bluetooth device
          </button>
        )}
      </div>

      <textarea
        value={token}
        onChange={(event) => {
          setToken(event.target.value);
        }}
        rows="10"
        cols="60"
        placeholder="Token here..."
      />
      <div>
        <button onClick={executeToken}>Execute</button>
      </div>

      {!supportsBluetooth && (
        <p>This browser doesn't support the Web Bluetooth API</p>
      )}
    </div>
  );
}

export default App;
